<template>
  <div class="promotionContainer u-bg-white" v-bind:class="{ '-seimei': isSeimei }">
    <div v-html="promotionData"></div>
  </div>
</template>

<script>
export default {
  name: 'promotion-container',
  props: {
    promotionData: { type: String, default: '' },
    isSeimei: false
  }
};
</script>

<style lang="scss">
.promotionContainer {
  width: 100%;
  max-width: 580px;
  margin: auto;
  padding: 0 16px;
  p {
    margin: 0;
  }
  img {
    width: auto;
    max-width: 100%;
    display: block;
  }
  .row {
    margin-left: -16px;
    margin-right: -16px;
  }
  &.-seimei {
    padding: 0;
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/PromotionContainer.vue